import * as React from "react";
import { getDisplayName } from "@grandvisionhq/utils";
import { useBreakpointVisibility } from "../../hooks/hooks/use-breakpoint-visibility.js";
function withBreakpointVisibility(Component) {
  const displayName = getDisplayName(Component);
  const WithBreakpointVisibility = (props) => {
    return useBreakpointVisibility(props) ? /* @__PURE__ */ React.createElement(Component, { ...props }) : null;
  };
  WithBreakpointVisibility.displayName = `WithBreakpointVisibility(${displayName})`;
  return WithBreakpointVisibility;
}
export {
  withBreakpointVisibility
};
//# sourceMappingURL=with-breakpoint-visibility.js.map
